<template>
  <div class="case-page">
    <div class="case-inner">
      <!-- 插画：纯 CSS 搭建中的方块 -->
      <div class="illustration">
        <div class="circle-bg"></div>
        <div class="blocks">
          <div class="block block-1"></div>
          <div class="block block-2"></div>
          <div class="block block-3"></div>
        </div>
        <div class="gear">
          <i class="el-icon-setting"></i>
        </div>
      </div>

      <!-- 文案 -->
      <h1 class="case-title">成功案例</h1>
      <p class="case-desc">
        该模块正在精心打磨中，敬请期待
        <span class="loading-dots">
          <i></i><i></i><i></i>
        </span>
      </p>

      <!-- 操作 -->
      <div class="case-actions">
        <button class="btn-primary" @click="goHome">返回首页</button>
        <button class="btn-ghost" @click="goContact">联系我们</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Case",
  methods: {
    goHome() {
      this.$router.push({ name: "Index" });
    },
    goContact() {
      this.$router.push({ name: "Contact" });
    },
  },
};
</script>

<style lang="scss" scoped>
.case-page {
  width: 100%;
  min-height: calc(100vh - 64px); // 减顶部固定导航高度
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #eaf4ff 0%, #f6faff 100%);
  padding: 60px 0;
}

.case-inner {
  text-align: center;
  animation: fadeInUp 0.5s ease;
}

/* ============ 插画区 ============ */
.illustration {
  position: relative;
  width: 240px;
  height: 200px;
  margin: 0 auto 40px;
}

.circle-bg {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 180px;
  height: 180px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: linear-gradient(135deg, #d6e7ff 0%, #eaf3ff 100%);
}

.blocks {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  width: 140px;
  height: 110px;
}

.block {
  position: absolute;
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(57, 130, 247, 0.25);
}

.block-1 {
  left: 0;
  bottom: 0;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #3982f7, #5aa0ff);
  animation: float 3s ease-in-out infinite;
}

.block-2 {
  right: 0;
  bottom: 0;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #78b4ff, #a8d0ff);
  animation: float 3s ease-in-out 0.4s infinite;
}

.block-3 {
  left: 38px;
  bottom: 64px;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #ffffff, #eaf3ff);
  border: 2px dashed #9cc4ff;
  box-shadow: none;
  animation: float 3s ease-in-out 0.8s infinite;
}

.gear {
  position: absolute;
  right: 22px;
  top: 10px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 8px 16px rgba(57, 130, 247, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 26px;
    color: #3982f7;
    animation: spin 6s linear infinite;
  }
}

/* ============ 文案 ============ */
.case-title {
  font-size: 32px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 16px;
}

.case-desc {
  font-size: 16px;
  color: #999999;
  margin: 0 0 40px;
  line-height: 28px;
}

/* 加载动效小圆点 */
.loading-dots {
  display: inline-flex;
  margin-left: 6px;

  i {
    width: 5px;
    height: 5px;
    margin-left: 4px;
    border-radius: 50%;
    background: #3982f7;
    animation: blink 1.2s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

/* ============ 按钮 ============ */
.case-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.btn-primary,
.btn-ghost {
  height: 44px;
  padding: 0 32px;
  border-radius: 22px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.25s ease;
  border: none;
  outline: none;
}

.btn-primary {
  background: #3982f7;
  color: #ffffff;
  box-shadow: 0 8px 16px rgba(57, 130, 247, 0.3);

  &:hover {
    background: #2b6fe0;
    transform: translateY(-2px);
    box-shadow: 0 12px 20px rgba(57, 130, 247, 0.35);
  }
}

.btn-ghost {
  background: #ffffff;
  color: #3982f7;
  border: 1px solid #c7dcff;

  &:hover {
    border-color: #3982f7;
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(57, 130, 247, 0.15);
  }
}

/* ============ 动画 ============ */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-8px);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes blink {
  0%,
  100% {
    opacity: 0.25;
  }

  50% {
    opacity: 1;
  }
}
</style>
